import { domainStore } from '@/store/domain-store';
import { userStore } from '@/store/user-store';
import axios from 'axios';
import { setupCache } from 'axios-cache-interceptor';

const axiosBasic = axios.create({
  headers: {
    Accept: 'application/json',
  },
});

const axiosWdwDomain = axios.create({
  baseURL: process.env.VUE_APP_SERVER_BASE_URL,
  headers: {
    Accept: 'application/json',
  },
});

const axiosWdw = axios.create({
  baseURL: process.env.VUE_APP_SERVER_BASE_URL + 'api/v1/',
  headers: {
    Accept: 'application/json',
    'content-type': 'application/json',
  },
});

const axiosWdwCached = setupCache(
  axios.create({
    baseURL: process.env.VUE_APP_SERVER_BASE_URL + 'api/v1/',
    headers: {
      Accept: 'application/json',
      'content-type': 'application/json',
    },
  }),
  {
    headerInterpreter: (headers: any) => {
      // Required so that we can ignore the "no-cache" policy from server
      return { cache: 60, stale: 60 }; // 60 seconds TTL
    },
  }
);

const domainEndpoint = function () {
  // Get the domainid from DomainStore
  const domainid = domainStore.getState().domainid;
  if (domainid) {
    return 'domain/' + domainid;
  } else {
    console.error('domainid not initiated');
  }
};

axiosWdw.interceptors.request.use(request => {
  // Interceptor to add Bearer token if we have it set in userStore
  const authToken = userStore.getState().authToken;

  // console.log(authToken);
  if (authToken) {
    // console.log("setting auth-token header to request");
    request.headers['Authorization'] = 'Bearer ' + authToken;
  }

  if (domainStore.getState().language) {
    // domain-language is optionally provided as prop to individual components
    request.params = {
      // add default query-params (send with every request)
      lang: domainStore.getState().language,
      // spread the request's params
      ...request.params,
    };
  }

  // console.log('Starting Request', JSON.stringify(request, null, 2))
  return request;
});

axiosWdwCached.interceptors.request.use(request => {
  // Interceptor to add Bearer token if we have it set in userStore
  const authToken = userStore.getState().authToken;

  // console.log(authToken);
  if (authToken) {
    // console.log("setting auth-token header to request");
    request.headers['Authorization'] = 'Bearer ' + authToken;
  }
  // console.log(request.headers);

  // console.log('Starting Request', JSON.stringify(request, null, 2))
  return request;
});

axiosWdwDomain.interceptors.request.use(request => {
  // Interceptor to add Bearer token if we have it set in userStore
  const authToken = userStore.getState().authToken;
  // console.log(authToken);
  if (authToken) {
    // console.log("setting auth-token header to request");
    request.headers['Authorization'] = 'Bearer ' + authToken;
  }

  // console.log('Starting Request', JSON.stringify(request, null, 2))
  return request;
});

export { axiosBasic, axiosWdw, axiosWdwCached, axiosWdwDomain, domainEndpoint };
//  "axios": "^0.21.1",
